let PackagesItem = [
    {
        trackJunior: true,
        trackTitle: "Junior Track",
        trackSubtitle: true,
        trackPrice: "0",
        runningString: true,
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticketfree/1681805348523x996967014095913000',
    },
    {
        trackFull: true,
        trackTitle: "FULL ACCESS 🔥",
        trackSubtitle: "ticket",
        runningString: true,
        trackPrice: "189",
        earlyBird: "early birds price",
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Junior and Senior Track Access',
        trackLink: 'https://geekle.us/ticket/1681805409188x869240508587180000',
    },
    {
        trackTitle: "YEAR OF REACT ❤️",
        trackSubtitle: "package",
        runningString: true,
        trackPrice: "249",
        earlyBird: "one year access",
        trackDesc: "1",
        trackText: true,
        yearTrackText: true,
        trackText1: "One Year Package",
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticket/1695906604671x617634886694207500',
    },
    {
        newPremium: true,
        trackTitle: "GEEKLE PREMIUM",
        trackSubtitle: "MEMBERSHIP",
        trackPriceApperance: 2,
        trackPrice: "399",
        trackText: true,
        trackText1: "One Year Premium Membership",
        trackDesc: "1",
        trackButton: "BUY",
        trackLink: 'https://buy.stripe.com/00g8A760U4V98ak8wI',
        inverseColors: true,
    },
    // {
    //     trackTitle: "TEAM-5",
    //     trackSubtitle: "YEAR GROUP PACKAGE",
    //     trackPriceApperance: 3,
    //     runningString: true,
    //     trackPrice: "999",
    //     trackText: true,
    //     trackText1: "One Year Pass for 5 team members",
    //     trackDesc: "1",
    //     trackButton: "BUY",
    //     trackLink: 'https://geekle.us/ticket/1694109810106x843614570263085000',
    // },
    // {
    //     trackMode: 'Halloween',
    //     trackTitle: "FRANKENSTEIN'S HALLOWEEN 3+1 PACK",
    //     trackSubtitle: true,
    //     trackPrice: "179",
    //     trackText: true,
    //     trackButton: "GRAB SPOOKY DEAL",
    //     trackLink: 'https://geekle.us/ticket/1698044453451x220433225697198100',
    // },
    {
        trackTitle: "UNLIMITED",
        trackSubtitle: "YEAR ENTERPRISE PACKAGE",
        trackPriceApperance: 4,
        runningString: true,
        trackPrice: "Ask Our Manager",
        trackText: true,
        trackText1: "One Year Pass for up to 100 members",
        trackDesc: "1",
        trackButton: "Get Offer",
        trackLink: 'enterprise',
        validDate: '9.06',
    },
];

export default PackagesItem;
